if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
        refreshcart();
//           this.cartNotification.renderContents(response);
        setTimeout(function(){
          $('body').addClass('drawer--active');
          $('html').addClass('outline-disabled, disable-scroll');
          $('[data-drawer-push]').attr('aria-hidden',false);
        },500);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
//   Custom cart and Progressbar
function refreshcart(){
  var cartcontent = $('.cart-drawer__content-container'),
      cartprice = $('.cart-drawer__footer-container');
  fetch(``.concat("?section_id=").concat('cart-drawer', "&timestamp=").concat(Date.now()), {
    credentials: 'same-origin',
    method: 'GET'
  }).then(function (content) {
    content.text().then(function (html) {
      var tempElement = document.createElement('div');
      tempElement.innerHTML = html;
      $('#shopify-section-cart-drawer').find('.cart-drawer').html(tempElement.querySelector('.cart-drawer').innerHTML);
    });
  });
  fetch('/cart.js').then(res => res.json()).then((cart) => {
    if(cart.item_count == 0){
      $('#cart-icon-bubble span.item_count').hide();
    }else{
      $('#cart-icon-bubble span.item_count').html(cart.item_count);
    }
  });
}
function cartUpdate(update){
  jQuery.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: update,
    dataType: 'json',
    success: function(res) {
      refreshcart();
    }
  });
}
$(document).on('click','.cart-drawer__close-button',function(evt){
  $('body').removeClass('drawer--active');
  $('html').removeClass('outline-disabled, disable-scroll');
  $('[data-drawer-push]').attr('aria-hidden',true);
});
$(document).on('click','[data-cart-item-delete]',function(){
  let key = $(this).data('item-key'),
      update = { updates: {} };
  update.updates[key] = 0;
  cartUpdate(update);
});
//     Cart Qty Update With '+' and '-'
$(document).on('click','.js-btnqty',function(evt){
  var PluMinbtn = $(this),
      Oldvalue = PluMinbtn.parent().find('[data-cart-item-input-quantity]').val(),
      inputqty = PluMinbtn.parent().find('[data-cart-item-input-quantity]');
  if((PluMinbtn).hasClass('icon-plus')) {
    var Newvalue = parseFloat(Oldvalue) + 1;
    PluMinbtn.parent().find('[data-cart-item-input-quantity]').val(Newvalue);
    PluMinbtn.parent().find('[data-cart-item-input-quantity]').trigger('change');
    let quantity = PluMinbtn.parent().find('[data-cart-item-input-quantity]').val(),
        key = PluMinbtn.parent().find('[data-cart-item-input-quantity]').data('item-key'),
        update = { updates: {} };
    update.updates[key] = quantity;
    cartUpdate(update);
  }else {
    if((Oldvalue > 1)) {
      var Newvalue = parseFloat(Oldvalue) - 1;
      PluMinbtn.parent().find('[data-cart-item-input-quantity]').val(Newvalue);
      PluMinbtn.parent().find('[data-cart-item-input-quantity]').trigger('change');
      let quantity = PluMinbtn.parent().find('[data-cart-item-input-quantity]').val(),
          key = PluMinbtn.parent().find('[data-cart-item-input-quantity]').data('item-key'),
          update = { updates: {} };
      update.updates[key] = quantity;
      cartUpdate(update);
    }
  }
  let $input = inputqty;
  let id = $input.closest('[data-cart-item]').attr('[data-cart-item-id]');
  let lineItemNumber = parseInt(
    $input.closest('[data-cart-item]').attr('[data-cart-item-line-number]')
  );
  let quantity = $input.val();
  if (quantity === '') return;
});
$(document).on('change','[data-cart-item-input-quantity]',function(){
  let quantity = $(this).val(),
      key = $(this).data('item-key'),
      update = { updates: {} };
  update.updates[key] = quantity;
  cartUpdate(update);
});
